import React, { useRef, useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { parseIABDescription } from '@module/consent-manager';

export function DescriptionContainer({ children, isVisible }) {
  const [height, setHeight] = useState(0);
  const container = useRef(null);

  useEffect(() => {
    if (container && isVisible) {
      setHeight(container.current.scrollHeight);
    } else {
      setHeight(0);
    }
  }, [container, isVisible]);

  return (
    <div
      style={{ maxHeight: `${height}px` }}
      ref={container}
      className="consent__content"
    >
      {children}
    </div>
  );
}

DescriptionContainer.propTypes = {
  children: PropTypes.node,
  isVisible: PropTypes.bool,
};

function Descriptions({ title, descriptions }) {
  if (descriptions?.length > 0) {
    return (
      <React.Fragment>
        <p>{title}</p>
        <ul>
          {descriptions.map((p, i) => (
            <li key={i}>{p}</li>
          ))}
        </ul>
      </React.Fragment>
    );
  }
  return null;
}

Descriptions.propTypes = {
  title: PropTypes.string,
  descriptions: PropTypes.arrayOf(PropTypes.string),
};

export function PurposeDescription({ description }) {
  const [titles, lists] = parseIABDescription(description);
  return (
    <div className="consent__text">
      {Object.keys(titles).map((section) => (
        <Descriptions
          key={section}
          title={titles[section]}
          descriptions={lists[section]}
        />
      ))}
    </div>
  );
}

PurposeDescription.propTypes = {
  description: PropTypes.string,
};

export function VendorDescription({
  purposeDescriptions,
  featureDescriptions,
  policyUrl,
}) {
  return (
    <div className="consent__text">
      {/* We don't have translations for this yet */}
      <Descriptions title="Consent" descriptions={purposeDescriptions} />

      {/* We don't have translations for this yet */}
      <Descriptions title="Features" descriptions={featureDescriptions} />

      <p>
        <a target="_blank" rel="noreferrer" href={policyUrl}>
          {policyUrl}
        </a>
      </p>
    </div>
  );
}

VendorDescription.propTypes = {
  purposeDescriptions: PropTypes.arrayOf(PropTypes.string),
  featureDescriptions: PropTypes.arrayOf(PropTypes.string),
  policyUrl: PropTypes.string,
};
